import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { getKeycloakRedirectUri } from '../../environments';
import { registrationUrl } from './quicklinks-attribution';

type ProfileSignupPromptProps = {
  open: boolean;
  channelName: string;
  onClose: () => void;
};

export function profileSignupRedirectUri(): string {
  const redirectUri = getKeycloakRedirectUri();
  const joiner = redirectUri.includes('?') ? '&' : '?';
  return `${redirectUri}${joiner}signUpSource=profile-page`;
}

export function startProfileSignup(channelName: string): void {
  localStorage.setItem('referringChannelId', channelName);
  window.location.href = registrationUrl(profileSignupRedirectUri());
}

export default function ProfileSignupPrompt({
  open,
  channelName,
  onClose,
}: ProfileSignupPromptProps): JSX.Element {
  const history = useHistory();
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>Create your QuickCam account</DialogTitle>
      <DialogContent>
        Sign up with this profile as your referrer, or learn more about QuickCam
        first.
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Close</Button>
        <Button onClick={() => history.push(`/${encodeURIComponent(channelName)}`)}>
          Learn More
        </Button>
        <Button variant="contained" onClick={() => startProfileSignup(channelName)}>
          Sign Up Now
        </Button>
      </DialogActions>
    </Dialog>
  );
}
